document.addEventListener('DOMContentLoaded', () => {
  const handles = document.querySelectorAll('.resizable-handle');

  if (!handles.length) {
    console.error('No resizable handles found.');
    return; // Exit if no handles are found
  }

  handles.forEach(handle => {
    let isResizing = false;
    const banner = handle.closest('.banner');

    if (!banner) {
      console.error('No parent .banner found for handle:', handle);
      return;
    }

    handle.addEventListener('mousedown', (event) => {
      isResizing = true;
      document.body.style.cursor = 'row-resize';

      const onMouseMove = (event) => {
        if (isResizing) {
          const newHeight = event.clientY - banner.getBoundingClientRect().top;
          if (newHeight > 100) { // Minimum height constraint
            banner.style.height = `${newHeight}px`;
          }
        }
      };

      const onMouseUp = () => {
        isResizing = false;
        document.body.style.cursor = 'default';
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });
  });
});
